
export class Test {

    id: number;
    nome: string;
    durata: string;
    audio: string;

}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/_model/Test.ts